import { render, staticRenderFns } from "./UpdateInspections.vue?vue&type=template&id=63884d8a&scoped=true&"
import script from "./UpdateInspections.vue?vue&type=script&lang=ts&"
export * from "./UpdateInspections.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateInspections.vue?vue&type=style&index=0&id=63884d8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63884d8a",
  null
  
)

export default component.exports